import React, { useState, useEffect } from   'react';
import { NavLink, useParams} from 'react-router-dom';
import { useForm } from 'react-hook-form';
import apiService from '../../Auth/apiService';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip'; 
import { useAuth } from '../../Auth/AuthContext';

export default function FormularioPrevisitas(){
    const { token } = useAuth();
    const { idPrevisita } = useParams();
    const [Cargando, setCargando] = useState(false);
    const [Encuestadores, setEncuestadores] = useState([]);
    const [TiposPrevisita, setTiposPrevisita] = useState([]);
    const { handleSubmit, register, setValue, getValues, formState: { errors }} = useForm();
    const [swalProps, setSwalProps] = useState({});
    
    useEffect(() => {
        fetchData();
    }, []);
    const fetchData = async () => {
        let url = `/encuestassv/previsitas/crearformularioprevisitas`;
        let obj = { idPrevisita: idPrevisita}
        try {
        setCargando(true);
        const response = await apiService.post(url, obj, token);
        const result = await response.data;
        setEncuestadores(result.usuarios);
        setTiposPrevisita(result.tiposprevisita)
        if(result.previsita){
            setValue('id', result.previsita.id)
            setValue('preDocumento', result.previsita.preDocumento)
            setValue('prePrimernombre', result.previsita.prePrimernombre)
            setValue('preSegundonombre', result.previsita.preSegundonombre)
            setValue('prePrimerapellido', result.previsita.prePrimerapellido)
            setValue('preSegundoapellido', result.previsita.preSegundoapellido)
        }
        } catch (error) {
        console.error('Error fetching data:', error);
        } finally {
        setCargando(false);
        }
    };
    function EditarEstadoCivil (row){
        setMuestraFormulario(true);
        setValue('id', row.id);
        setValue('estEstadocivil', row.estEstadocivil);
        setValue('estActivo', row.estActivo);
    };
    const NuevoEstadoCivil = () =>  {
        setValue('id', 0);
        setValue('estEstadocivil', '');
        setValue('estActivo', false);
        setMuestraFormulario(true);
    }
    const onSubmit = async (data) => {
        setCargando(true);
        let url;
        url = '/parametros/guardarestadocivil';
        try {
            const response = await apiService.post(url, data, token);
            if(response.status === 200){
                Mensaje('Guardar tipo estudio', JSON.stringify(response.data));
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Guardar tipo estudio', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Guardar tipo estudio', JSON.stringify(error.response.data));
            }
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
            fetchData();
            ResetForm();
        }
    };
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    const ResetForm = () => {
        setValue('id', 0);
        setValue('estEstadocivil', '');
        setValue('estActivo', false);
        setMuestraFormulario(false);
    }
    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Formulario previsitas</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                            <li className="breadcrumb-item"><NavLink to={`/`} >Inicio</NavLink></li>
                            <li className="breadcrumb-item"><NavLink to={`/encuestassv/previsitas`} > Previsitas SSV</NavLink></li>
                            <li className="breadcrumb-item active"> Previsitas</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
            <section className="content">
                <div className="container-fluid">
                      {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                      </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <div className='row'>
                        <div className='col-md-5'>
                            <div className="card">
                            <div className='card-header'>
                                <h3 className='card-title'>Formulario</h3>
                            </div>
                            
                            <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                                <div className="card-body">
                                    
                                    <input hidden {...register('id')}/>
                                    
                                    <div className='row'>
                                        <div className='col-md-12'>
                                            <p><b>Id: </b><span className="form-label" id="pid">{getValues('id')}</span></p>
                                            <p><b>Documento: </b><span className="form-label" id="documento">{getValues('preDocumento')}</span></p>
                                            <p> <b>Nombres: </b><span className="form-label" id="primernombre">{getValues('prePrimernombre')}</span> <span className="form-label" id="segundonombre">{getValues('preSegundonombre')}</span>        </p>
                                            <p><b>Apellidos: </b><span className="form-label" id="primerapellido">{getValues('prePrimerapellido')}</span> <span className="form-label" id="segundoapellido">{getValues('preSegundoapellido')}</span>        </p>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-12'>
                                            <div className="input-group mb-3">
                                                <span className="input-group-text">Propietario</span>
                                                <select className="form-select" id="propietario" {...register('prePropietario', { required: true })}>                
                                                    <option selected value=""></option>
                                                    <option value="SI">SI</option>
                                                    <option value="NO">NO</option>
                                                </select>
                                                {errors.prePropietario && <p style={{color: 'red'}}>Seleccione propietario</p>}
                                            </div>
                                            <div className="input-group mb-3">
                                                <span className="input-group-text">Previsita</span>
                                                <select className="form-select" id="previsita" {...register('prePrevisita', { required: true })}>                
                                                    <option selected value=""></option>
                                                    {TiposPrevisita.map((item) => (
                                                    <option key={item.id} value={item.id}>
                                                        {item.id}-{item.tipTipoprevistia}
                                                    </option>
                                                    ))}
                                                </select>
                                                {errors.prePrevisita && <p style={{color: 'red'}}>Seleccione tipo previsita</p>}
                                            </div>
                                            <div className="input-group mb-3">
                                                <span className="input-group-text">Vacunado</span>
                                                <select className="form-select" id="vacunado" {...register('preVacunado', { required: true })}>                
                                                    <option selected value=""></option>
                                                    <option value="SI">SI</option>
                                                    <option value="NO">NO</option>
                                                </select>
                                                {errors.preVacunado && <p style={{color: 'red'}}>Seleccione vacunado</p>}
                                            </div>
                                            <div className="input-group mb-3">
                                                <span className="input-group-text">Logista</span>
                                                <input readonly id="logista" type="text" className="form-control" />                        
                                            </div>
                                            <div className="input-group mb-3">
                                                <span className="input-group-text">Encuestador</span>
                                                <select className="form-select" id="encuestador" {...register('preEncuestador', { required: true })}>   
                                                    <option selected value=""></option>
                                                    {Encuestadores.map((item) => (
                                                    <option key={item.id} value={item.id}>
                                                        {item.id}-{item.usrNombre}
                                                    </option>
                                                    ))}            
                                                </select>
                                                {errors.preEncuestador && <p style={{color: 'red'}}>Seleccione encuestador</p>}
                                            </div>
                                            <div className="form-floating">
                                                <textarea className="form-control" height="200" placeholder="Observaciones" id="observacion" {...register('preObservacion')}></textarea>            
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="card-footer">
                                    <div className='row'>
                                        <div className='col-md-1'>
                                            <button id="ActualizarPrevisita" type="submit" className="btn btn-info">Actualizar</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        </div>
                    </div>
                    
                </div>
            </section>
            <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
            <Tooltip id="tooltiparriba" place="right"/>
        </div>
    );
}